import {
  StyledContainer,
  StyledHalfImage,
  StyledSvgWrapper,
  StyledWrapper,
} from "components/general/stylingHero";
import asyncComponent from "components/split/asyncComponent";
import styled from "styled-components";

const SvgPrivacy = asyncComponent(() => import("components/privacy/svgPrivacy"));

const StyledCatSvg = styled(SvgPrivacy)`
  height: 400px;
  @media screen and (max-width: 768px) {
    height: auto;
    width: 100%;
  }
`;

const Hero = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <div className="hero__half">
          <h1 className="hero__title">Privacy Policy</h1>
        </div>
        <StyledHalfImage>
          <StyledSvgWrapper>
            <StyledCatSvg />
          </StyledSvgWrapper>
        </StyledHalfImage>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Hero;
